export enum InviteFormFields {
  email = 'email',
  firstName = 'firstName',
  lastName = 'lastName',
  displayName = 'displayName',
}

export type InviteFormValues = {
  [InviteFormFields.email]: string;
  [InviteFormFields.firstName]: string;
  [InviteFormFields.lastName]: string;
  [InviteFormFields.displayName]: string;
};
